import { TextInputProps as RNTextInputProps } from 'react-native';
import { memo, useEffect, useState } from "react";
import { StyledInputs, StyledTextInputProps } from "../styled/form/Inputs";
import { StyledForms } from "../styled/form/Form";
import { useInput } from "@app/hooks/useInput";
import { theme } from '@app/theme';

export interface TimeSlotInputProps extends RNTextInputProps, StyledTextInputProps {
  name: string;
  showError?: boolean;
  index: number;
  day: string;
  onPress?: () => void;
}

const timeSlotRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9] - ([01]?[0-9]|2[0-3]):[0-5][0-9]$/;

export const TimeSlotInput = memo(({ name, showError = true, day, index, onPress, ...props }: TimeSlotInputProps) => {
  const { field, error, formState } = useInput(name);

  const dayError = formState.errors.availabilitySchedule?.[day];

  const shouldShowError = showError && dayError && dayError[index];

  // const [value, setValue] = useState<string | null>(field.value || null);

  // useEffect(() => {
  //     setValue(field.value || null);
  // }, [field.value]);

  // const onChangeText = (text: string) => {
  //     if (text.match(timeSlotRegex)) {
  //         setValue(text);
  //         field.onChange(text);
  //     }
  // }

  return (
    <StyledInputs.Holder onPress={onPress}>
      {(!!error && showError) && (
        <StyledForms.Error>
          <StyledForms.ErrorLabel>
            {error}
          </StyledForms.ErrorLabel>
        </StyledForms.Error>
      )}

      <StyledInputs.Input
        onChangeText={field.onChange}
        onBlur={field.onBlur}
        value={field.value}
        // value={value as string}
        editable={false}
        ref={field.ref}
        error={shouldShowError || !!error}
        {...props} />
    </StyledInputs.Holder>
  );
});